import { inject } from 'vue'
import { QuestionType, Unique } from '@/types'

export function useQuestion() {
  const data = inject<{
    question: any
  }>(Unique, {
    question: {},
  })
  const {
    content = {},
    title = '',
    index = 1,
    is_necessary = false,
    is_random = false,
    jump = {},
    question_id = 0,
    options = [],
    question_type = '',
  } = data.question.value ?? {}
  return {
    ...data,
    title,
    is_necessary: question_type === QuestionType.InformationCollection ? false : is_necessary,
    is_random,
    jump,
    index,
    description: (content.description ?? '') as string,
    question_id,
    options: options.map((option: any) => {
      const { content, ...rest } = option
      return {
        ...rest,
        ...JSON.parse(content),
      }
    }),
    group: content?.group ?? [],
    content,
  }
}
